import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { debounceTime } from 'rxjs/operators';

import {
    CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR,
    ChangeSearchValueForRegionsSearchEditor,
    changeSuggestItemsForRegionsSearchEditor
} from '../../actions/regionsSearchEditor';
import { StringHelpers } from '../../service/StringHelpers/StringHelpers';
import { TreeHelpers } from '../../service/TreeHelpers/TreeHelpers';
import { DictionaryItem, Region } from '../../typings/common';
import { DnaEpic, DnaEpicAction } from '../../typings/epic';

const DEBOUNCE_TIME = 200;

export const changeSearchValueForRegionsSearchEditorEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(CHANGE_SEARCH_VALUE_FOR_REGIONS_SEARCH_EDITOR),
        debounceTime(DEBOUNCE_TIME),
        mergeMap(
            (action: ChangeSearchValueForRegionsSearchEditor): DnaEpicAction => {
                const { editorId, searchValue, regionTree } = action;

                if (!regionTree) {
                    return EMPTY;
                }

                const listSuggestItems: DictionaryItem[] = [];
                const trimmedSearchValue = searchValue.trim();

                if (searchValue.length > 0) {
                    TreeHelpers.each<Region>(regionTree, (node: Region, parent?: Region) => {
                        if (StringHelpers.indexOfSubstring(node.name, trimmedSearchValue) !== -1) {
                            listSuggestItems.push({
                                val: node.id,
                                text: parent ? `${parent.name} → ${node.name}` : node.name
                            });
                        }
                    });
                }

                return of(changeSuggestItemsForRegionsSearchEditor(editorId, listSuggestItems));
            }
        )
    );
};
